import { render } from "./PasswordResetSuccess.vue?vue&type=template&id=0856f7b8&scoped=true"
import script from "./PasswordResetSuccess.vue?vue&type=script&lang=js"
export * from "./PasswordResetSuccess.vue?vue&type=script&lang=js"

import "./PasswordResetSuccess.vue?vue&type=style&index=0&id=0856f7b8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0856f7b8"]])

export default __exports__